import { combineReducers } from "redux";
import LoginReducer from "./common/LoginReducer";
import RegistrationReducer from "./common/RegistrationReducer";
import VerificationReducer from "./common/VerificationReducers";
import NotificationsReducer from "./user/NotificationsReducer";
import MfaAuthenticationsReducer from "./common/MfaAuthenticationsReducer";
import workspaces_TeamMember_Reducer from "./user/WorkspacesTeamMemberReducer";
import workspaces_List_Reducer from "./user/WorkspacesListReducer";
import workspaces_Create_Reducer from "./user/WorkspacesCreateReducer";
import ForgetPasswordReducer from "./common/ForgetPasswordReducer";
import LoginVerificationReducer from "./common/LoginVerificationReducer";
import workspaces_Details_Reducer from "./user/WorkspaceDetailsReducer";
import workspaces_folder_create_Reducer from "./user/WorkspaceFolderCreateReducer";
import workspaces_FolderList_Reducer from "./user/WorkspaceFolderListReducer";
import workspaces_QuickList_Reducer from "./user/workspacesQuickListReducer";
import workspaces_Supporting_Document_FolderCreate_Reducer from "./user/WorkspaceSupportingDocumentFolderCreateReducer";
import workspaces_Supporting_Document_FolderEdit_Reducer from "./user/WorkspaceSupportingDocumentFolderEditReducer";
import workspaces_Output_Teamplate_folder_create_Reducer from "./user/WorkspaceOutputTemplateFolderCreateReducers";
import workspaces_Supporting_Document_FolderList_Reducer from "./user/WorkspaceSupportingDocumentList";
import workspaces_Output_Teamplate_Output_List_Reducer from "./user/WorkspaceOutputTemplateList";
import workspaces_Data_Details_Reducer from "./user/WorkspaceDataDetailsReducer";
import Dashboard_Quick_Actions_Created_Reducer from "./user/DashboardQuickActionsCreatedReducer";
import Dashboard_Time_Created_Reducer from "./user/DashboardTimeCreatedReducer";
import Dashboard_Recently_Used_Quick_Actions_Reducer from "./user/DashboardRecentlyUsedQuickActionsReducer";
import Dashboard_Bookmarked_Quick_Actions_Reducer from "./user/DashboardBookmarkedQuickActionsReducer";
import Dashboard_Public_Quick_Actions_Reducer from "./user/DashboardPublicQuickActionsReducer";
import Dashboard_Team_Members_Reducer from "./user/DashboardTeamMembersReducer";
import BuildQuickOutputCreateSupportingDocumentsReducer from "./user/BuildQuickOutputCreateSupportingDocumentsReducer";
import BuildQuickFileUploadReducer from "./user/BuildQuickFileUploadReducer";
import BuildQuickCreateSupportingDocumentsReducer from "./user/BuildQuickCreateSupportingDocumentsReducer";
import BuildQuickOutPutFileUploadReducer from "./user/BuildQuickOutPutFileUploadReducer";
import WorkspaceAccessReducer from "./user/WorkspaceAccessReducer";
import SettingsWorkspaceAnalyticsReducer from "./user/SettingsWorkspaceAnalyticsReducer";
import SettingsUserProfileReducer from "./user/SettingsUserProfileReducer";
import SettingsEditProfileReducer from "./user/SettingsEditProfileReducer";
import SettingsChangePasswordReducer from "./user/SettingsChangePasswordReducer";
import SettingsOrGeneratorReducer from "./user/SettingsOrGeneratorReducer";
import SettingsCodeVerifyReducer from "./user/SettingsCodeVerifyReducer";
import SettingsWorkspaceAccessRequestsReducer from "./user/SettingsWorkspaceAccessRequestsReducer";
import SettingsActionWorkspaceAccessRequestsReducer from "./user/SettingsActionWorkspaceAccessRequestsReducer";
import WorkspaceBookmarkToggleReducer from "./user/WorkspaceBookmarkToggleReducer";
import QuickActionCopyReducer from "./user/QuickActionCopyReducer";
import build_Quick_Action_Reducer from "./user/BuildQuickActionReducer";
import build_Quick_Action_Update_Reducer from "./user/BuildQuickActionUpdateReducer";
import build_Action_Copy_Reducer from "./user/BuildQuickActionCopy";
import get_User_output_format_Reducer from "./user/GetUserOutputFormatReducer";
import get_User_supporting_Docs_Reducer from "./user/GetUserSupportingDocsReducer";
import build_Action_Supporting_Document_Quick_Run_Reducer from "./user/BuildQuickActionQuickSearchReducer";
import userManagement_Roles_Reducer from "./user/UserManagementRolesReducer";
import userManagement_Roles_list_Reducer from "./user/UserManagementRolesListReducer";
import userManagement_Roles_create_Reducer from "./user/UserManagementCreateRolesReducer";
import userManagement_Roles_update_Reducer from "./user/UserManagementUpdateRolesReducer";
import ProductsReducer from "./user/ProductsReducer";
import SubscriptionsReducer from "./user/SubscriptionsReducer";
import SubscriptionsCancleReducer from "./user/SubscriptionsCancleReducer";
import ProductsPlanReducer from "./user/ProductsPlanReducer";
import WorkspaceSupportDocumentsEditReducer from "./user/WorkspaceSupportDocumentsEditReducer";
import WorkspaceSupportDocumentsUpdateReducer from "./user/WorkspaceSupportDocumentsUpdateReducer";
import WorkspaceSupportDocumentsOutputEditReducer from "./user/WorkspaceSupportDocumentsOutputEditReducer";
import WorkspaceSupportDocumentsOutputUpdateReducer from "./user/WorkspaceSupportDocumentsOutputUpdateReducer";
import workspaces_Supporting_Document_FolderCreate_Restrict_Reducer from "./user/WorkspaceSupportingDocumentFolderCreateRestrictReducer";
import NotificationsReadReducer from "./user/NotificationsReadReducer";
import NotificationsReadAllReducer from "./user/NotificationsReadAllReducer";
import AcsessUser_Management_Reducer from "./user/AccessUserManagementListReducer";
import {
  create_Video_Guide_Reducer,
  list_Video_Guide_Reducer,
  list_edit_Video_Guide_Reducer,
  delete_Video_Guide_Reducer,
  edit_Video_Guide_Reducer,
} from "./user/CreateVideoGuideReducer";
import build_Quick_Action_By_Id_Reducer from "./user/BuildQuickActionDetailsByIdReducer";
import Run_quickAction_UploadFileReducer from "./user/RunQuickActionUploadFileReducer";
import quick_Action_Run_Status_Reducer from "./user/RunQuickActionStatusReducer";
import quick_Action_Run_Check_Reducer from "./user/RunQuickActionCheckReducer";
import quick_Action_Run_Upload_With_Fielid_Reducer from "./user/RunQuickActionUploadFileWithFileIdReducer";
import quick_Action_Run_Generate_Chunks_Reducer from "./user/RunQuickActionGenerateChunksReducer";
import quick_Action_Run_Save_Execute_Batch_Reducer from "./user/RunQuickActionSaveExecuteBatchReducer";
import run_Quick_Action_Run_Id_Reducer from "./user/RunQuickActionRunIdReducer";

import { create_play_chat_Reducer } from "./user/PlayChatReducer";
import Run_quickAction_UploadTextReducer from "./user/RunQuickActionUploadTextReducer";
import {
  create_play_query_Reducer,
  create_play_query_options_Reducer,
  create_play_query_folders_Reducer,
  create_play_query__supporting_folders_Reducer,
  create_play_query_library_reducer,
} from "./user/PlayQueryReducer";
import {
  create_play_history_Reducer,
  create_play_view_history_Reducer,
  chatDocumentReducer,
} from "./user/PlayHistoryReducer";

import SupportingDocumentDeleteReducer from "./user/SupportingDocumentDeleteReducer";
import SupportingOutputDocumentDeleteReducer from "./user/SupportingOutputDocumentDeleteReducer";
import workspaces_QuickHistory_Reducer from "./user/workspacesQuickHistoryReducer";
import workspaces_QuickSelf_Reducer from "./user/workspacesQuickSelfReducer";
import Dashboard_Team_Activity_Reducer from "./user/DashboardTeamActivityReducer";
import Quick_Action_Folder_Reducer from "./user/QuickActionFolderReducer";
import Quick_Action_Folder_List_Reducer from "./user/QuickActionFolderListReducer";
import Workspace_Roles_Permission_create_Reducer from "./user/workspaceRolePermissionCreateRoleReducer";
import Workspace_Role_Permission_Roles_list_Reducer from "./user/WorkspaceRolePermissionListReducer";
import workspace_Role_Permission_Update_Reducer from "./user/WorkspaceRolePermissionUpdateRole";
import {
  create_upload_faq_Reducer,
  create_get_topic_ques_list_Reducer,
  create_ques_list_Reducer,
  delete_ques_list_Reducer,
  update_parent_ques_list_Reducer,
} from "./user/UploadFAQReducer";
import { create_upload_faq_topic_list_Reducer } from "./user/UploadFAQTopicListReducer";
import workspaces_User_Create_Reducer from "./user/workspaces_User_Create_Reducer";
import userManagement_Roles_Delete_Reducer from "./user/UserManagementRoleDeleteReducer";
import workspace_Role_Delete_Reducer from "./user/WorkspaceRolePermissionRoleDeleteReducer";
import AccessUserManagementUpdateReducer from "./user/AccessUserManagementUpdateReducer";
import workspacesSupportingDocumentsIdReducer from "./user/workspacesSupportingDocumentsIdReducer";
import workspacesOutputFormatsIdReducer from "./user/workspacesOutputFormatsIdReducer";
import QuickActionDeleteReducer from "./user/QuickActionDeleteReducer";
import {
  create_upload_document_Reducer,
  list_upload_document_Reducer,
  edit_upload_document_Reducer,
  delete_upload_document_Reducer,
} from "./user/UploadDocumentReducer";
import Run_quick_Action_Update_Output_Name_Reducer from "./user/RunQuickActionOutputUpdateNameReducer";
import SettingsUserAnalyticsReducer from "./user/SettingsUserAnalyticsReducer";
import Run_Quick_Action_History_Access_Reducer from "./user/RunQuickActionHistoryAccessReducer";
import SupportingDocumentUserDeleteReducer from "./user/SupportingDocumentUserDeleteReducer";
// import SupportingDocumentDeleteReducer from "./user/SupportingDocumentDeleteReducer";
import SettingsClientAnalyticsReducer from "./user/SettingsClientAnalyticsReducer";
import SettingsOwnerAnalyticsReducer from "./user/SettingsOwnerAnalyticsReducer";
import workspaces_Admin_Create_Reducer from "./user/WorkspacesAdminCreateReducer";
import SettingsUserProfileMraReducer from "./user/SettingsUserProfileMraReducer";
import WorkspaceSupportDocumentsTokenReducer from "./user/WorkspaceSupportDocumentsTokenReducer";
// import WorkspaceSupportDocumentsUpdateReducer from "./user/WorkspaceSupportDocumentsUpdateReducer";
import SettingsWorkspaceAccessTokenRequestsReducer from "./user/SettingsWorkspaceAccessTokenRequestsReducer";
import SettingsActionWorkspaceAccessTokenRequestsReducer from "./user/SettingsActionWorkspaceAccessTokenRequestsReducer";
import EnterpriseClientsListReducer from "./user/EnterpriseClientsListReducer";
import PlayChat_Down_voteReducer from "./user/PlayChatConversationDownVoteReducer";
import Striped_Managed_client_list_Reducer from "./user/StripedManagedClientListReducer";
import Run_quick_Action_Update_Output_Feedback_Reducer from "./user/RunQuickActionOutputUpdateFeedbackReducer";
import Output_ListEditHistory_RunQa_Reducer from "./user/OutputListEditHistoryRunQaReducer";
import Rename_TitleEditHistory_RunQa_Reducer from "./user/RenameTitleEditHistoryRunQaReducer";
import Restored_Output_EditHistory_RunQaReducer from "./user/RestoredOutputEditHistoryRunQaReducer";
import Save_EditHistory_RunQaReducer from "./user/SaveEditHistoryRunQaReducer";
import workspaces_CustomList_Reducer from "./user/WorkspacesCustomListReducer";

const rootReducer = combineReducers({
  LoginData: LoginReducer,
  RegisterData: RegistrationReducer,
  VerificationData: VerificationReducer,
  NotificationsData: NotificationsReducer,
  NotificationsReadData: NotificationsReadReducer,
  NotificationsReadAllData: NotificationsReadAllReducer,
  MfaAuthenticationsData: MfaAuthenticationsReducer,
  workspaces_List_Data: workspaces_List_Reducer,
  workspaces_TeamMember_Data: workspaces_TeamMember_Reducer,
  workspaces_Create_Data: workspaces_Create_Reducer,
  ForgetPasswordData: ForgetPasswordReducer,
  LoginVerificationData: LoginVerificationReducer,
  workspaces_Details_Data: workspaces_Details_Reducer,
  workspaces_Data_Details_Data: workspaces_Data_Details_Reducer,
  Dashboard_Quick_Actions_Created_Data: Dashboard_Quick_Actions_Created_Reducer,
  Dashboard_Time_Created_Data: Dashboard_Time_Created_Reducer,
  Dashboard_Recently_Used_Quick_Actions_Data:
    Dashboard_Recently_Used_Quick_Actions_Reducer,
  Dashboard_Bookmarked_Quick_Actions_Data:
    Dashboard_Bookmarked_Quick_Actions_Reducer,
  Dashboard_Public_Quick_Actions_Data: Dashboard_Public_Quick_Actions_Reducer,
  Dashboard_Team_Members_Data: Dashboard_Team_Members_Reducer,
  workspaces_folder_create_Data: workspaces_folder_create_Reducer,
  workspaces_FolderList_Data: workspaces_FolderList_Reducer,
  workspaces_QuickList_Data: workspaces_QuickList_Reducer,
  workspaces_Supporting_Document_FolderCreate_Data:
    workspaces_Supporting_Document_FolderCreate_Reducer,
    workspaces_Supporting_Document_FolderEdit_Data:
    workspaces_Supporting_Document_FolderEdit_Reducer,
  workspaces_Output_Teamplate_folder_create_Data:
    workspaces_Output_Teamplate_folder_create_Reducer,
  workspaces_Supporting_Document_FolderList_Data:
    workspaces_Supporting_Document_FolderList_Reducer,
  workspaces_Output_Teamplate_Output_List_Data:
    workspaces_Output_Teamplate_Output_List_Reducer,
  BuildQuickOutputCreateSupportingDocumentsData:
    BuildQuickOutputCreateSupportingDocumentsReducer,
  BuildQuickFileUploadData: BuildQuickFileUploadReducer,
  BuildQuickCreateSupportingDocumentsData:
    BuildQuickCreateSupportingDocumentsReducer,
  BuildQuickOutPutFileUploadData: BuildQuickOutPutFileUploadReducer,
  WorkspaceAccessData: WorkspaceAccessReducer,
  SettingsWorkspaceAnalyticsData: SettingsWorkspaceAnalyticsReducer,
  SettingsUserProfileData: SettingsUserProfileReducer,
  SettingsEditProfileData: SettingsEditProfileReducer,
  SettingsChangePasswordData: SettingsChangePasswordReducer,
  SettingsOrGeneratorData: SettingsOrGeneratorReducer,
  SettingsCodeVerifyData: SettingsCodeVerifyReducer,
  SettingsWorkspaceAccessRequestsData: SettingsWorkspaceAccessRequestsReducer,
  SettingsActionWorkspaceAccessRequestsData:
    SettingsActionWorkspaceAccessRequestsReducer,
  WorkspaceBookmarkToggleData: WorkspaceBookmarkToggleReducer,
  QuickActionCopyData: QuickActionCopyReducer,
  build_Quick_Action_Data: build_Quick_Action_Reducer,
  build_Quick_Action_Update_Data: build_Quick_Action_Update_Reducer,
  build_Action_Copy_Data: build_Action_Copy_Reducer,
  build_Action_Supporting_Document_Quick_Run_Data:
    build_Action_Supporting_Document_Quick_Run_Reducer,
  get_User_output_format_Data: get_User_output_format_Reducer,
  get_User_supporting_Docs_Data: get_User_supporting_Docs_Reducer,
  userManagement_Roles_Data: userManagement_Roles_Reducer,
  userManagement_Roles_list_Data: userManagement_Roles_list_Reducer,
  userManagement_Roles_create_Data: userManagement_Roles_create_Reducer,
  userManagement_Roles_update_Data: userManagement_Roles_update_Reducer,
  create_video_guide_data: create_Video_Guide_Reducer,
  list_video_guide_data: list_Video_Guide_Reducer,
  delete_video_guide_data: delete_Video_Guide_Reducer,
  edit_video_guide_data: edit_Video_Guide_Reducer,
  ProductsData: ProductsReducer,
  SubscriptionsData: SubscriptionsReducer,
  SubscriptionsCancleData: SubscriptionsCancleReducer,
  ProductsPlanData: ProductsPlanReducer,
  create_video_guide_data: create_Video_Guide_Reducer,
  list_video_guide_data: list_Video_Guide_Reducer,
  delete_video_guide_data: delete_Video_Guide_Reducer,
  WorkspaceSupportDocumentsEditData: WorkspaceSupportDocumentsEditReducer,
  WorkspaceSupportDocumentsUpdateData: WorkspaceSupportDocumentsUpdateReducer,
  WorkspaceSupportDocumentsOutputEditData:
    WorkspaceSupportDocumentsOutputEditReducer,
  WorkspaceSupportDocumentsOutputUpdateData:
    WorkspaceSupportDocumentsOutputUpdateReducer,
  edit_video_guide_data: edit_Video_Guide_Reducer,
  AccsessUser_Management_Data: AcsessUser_Management_Reducer,
  build_Quick_Action_By_Id_data: build_Quick_Action_By_Id_Reducer,
  Run_quickAction_UploadFile_Data: Run_quickAction_UploadFileReducer,

  quick_Action_Run_Status_Data: quick_Action_Run_Status_Reducer,
  quick_Action_Run_Check_Data: quick_Action_Run_Check_Reducer,
  quick_Action_Run_Upload_With_Fielid_Data:
    quick_Action_Run_Upload_With_Fielid_Reducer,
  quick_Action_Run_Generate_Chunks_Data:
    quick_Action_Run_Generate_Chunks_Reducer,
  quick_Action_Run_Save_Execute_Batch_Data:
    quick_Action_Run_Save_Execute_Batch_Reducer,
  run_Quick_Action_Run_Id_Data: run_Quick_Action_Run_Id_Reducer,

  create_play_chat_data: create_play_chat_Reducer,
  create_play_query_data: create_play_query_Reducer,
  create_play_query_options_data: create_play_query_options_Reducer,
  create_play_query_folders_data: create_play_query_folders_Reducer,
  create_play_query_supporting_folders_data:
    create_play_query__supporting_folders_Reducer,
  create_play_query_library_data: create_play_query_library_reducer,
  create_play_history_data: create_play_history_Reducer,
  create_play_view_history_data: create_play_view_history_Reducer,
  chatDocument: chatDocumentReducer,
  SupportingDocumentDeletedata: SupportingDocumentDeleteReducer,
  SupportingOutputDocumentDeletedata: SupportingOutputDocumentDeleteReducer,
  workspaces_QuickHistory_Data: workspaces_QuickHistory_Reducer,
  workspaces_QuickSelf_Data: workspaces_QuickSelf_Reducer,
  Dashboard_Team_Activity_Data: Dashboard_Team_Activity_Reducer,
  Quick_Action_Folder_Data: Quick_Action_Folder_Reducer,
  Quick_Action_Folder_List_Data: Quick_Action_Folder_List_Reducer,
  Workspace_Role_Permission_Roles_list_Data:
    Workspace_Role_Permission_Roles_list_Reducer,
  Workspace_Roles_Permission_create_Data:
    Workspace_Roles_Permission_create_Reducer,
  workspace_Role_Permission_Update_Data:
    workspace_Role_Permission_Update_Reducer,
  create_upload_faq_data: create_upload_faq_Reducer,
  create_upload_faq_topic_list_data: create_upload_faq_topic_list_Reducer,

  create_topic_ques_list_data: create_get_topic_ques_list_Reducer,
  create_quest_list_data: create_ques_list_Reducer,
  delete_ques_list_data: delete_ques_list_Reducer,
  edit_parent_ques_list_data: update_parent_ques_list_Reducer,

  workspaces_User_Create_Data: workspaces_User_Create_Reducer,
  userManagement_Roles_Delete_Data: userManagement_Roles_Delete_Reducer,
  workspace_Role_Delete_Data: workspace_Role_Delete_Reducer,
  AccessUserManagementUpdateData: AccessUserManagementUpdateReducer,
  workspacesSupportingDocumentsIdData: workspacesSupportingDocumentsIdReducer,
  workspacesOutputFormatsIdData: workspacesOutputFormatsIdReducer,
  QuickActionDeleteData: QuickActionDeleteReducer,
  create_upload_documents_data: create_upload_document_Reducer,
  list_upload_documents_data: list_upload_document_Reducer,
  edit_upload_documents_data: edit_upload_document_Reducer,
  delete_upload_documents_data: delete_upload_document_Reducer,
  list_edit_video_guide_data: list_edit_Video_Guide_Reducer,
  SettingsUserAnalyticsData: SettingsUserAnalyticsReducer,

  Run_quick_Action_Update_Output_Name_Data:
    Run_quick_Action_Update_Output_Name_Reducer,

  Run_Quick_Action_History_Access_Data: Run_Quick_Action_History_Access_Reducer,
  SupportingDocumentUserDeletedata: SupportingDocumentUserDeleteReducer,
  SettingsClientAnalyticsData: SettingsClientAnalyticsReducer,
  SettingsOwnerAnalyticsData: SettingsOwnerAnalyticsReducer,
  workspaces_Admin_Create_Data: workspaces_Admin_Create_Reducer,
  SettingsUserProfileMraData: SettingsUserProfileMraReducer,
  WorkspaceSupportDocumentsTokenData: WorkspaceSupportDocumentsTokenReducer,
  SettingsWorkspaceAccessTokenRequestsData:
    SettingsWorkspaceAccessTokenRequestsReducer,
  SettingsActionWorkspaceAccessTokenRequestsData:
    SettingsActionWorkspaceAccessTokenRequestsReducer,
  EnterpriseClientsListData: EnterpriseClientsListReducer,
  PlayChat_Down_voteData: PlayChat_Down_voteReducer,
  Striped_Managed_client_list_Data: Striped_Managed_client_list_Reducer,
  Run_quick_Action_Update_Output_Feedback_Data:
    Run_quick_Action_Update_Output_Feedback_Reducer,
  Run_quickAction_UploadText_Data: Run_quickAction_UploadTextReducer,
    workspaces_Supporting_Document_FolderCreate_Restrict_Data:
    workspaces_Supporting_Document_FolderCreate_Restrict_Reducer,

  Output_ListEditHistory_RunQa_Data: Output_ListEditHistory_RunQa_Reducer,
  Rename_TitleEditHistory_RunQa_Data: Rename_TitleEditHistory_RunQa_Reducer,

  Restored_Output_EditHistory_RunQa_Data:
    Restored_Output_EditHistory_RunQaReducer,

  Save_EditHistory_RunQaReducer_Data: Save_EditHistory_RunQaReducer,
  workspaces_CustomList_Data: workspaces_CustomList_Reducer,
});
export default rootReducer;
